var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path0, _g5, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrendsReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 32,
    viewBox: "0 0 85 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 27.984L19.635 23.718L36.266 20.692L48.831 15.192L63.643 7.08002L80.849 4",
    stroke: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62 4.94679C60.3165 4.94679 58.9468 6.31645 58.9468 8C58.9468 9.68355 60.3165 11.0532 62 11.0532C63.6835 11.0532 65.0532 9.68355 65.0532 8C65.0532 6.31645 63.6835 4.94679 62 4.94679ZM62 4C64.2091 4 66 5.79085 66 8C66 10.2091 64.2091 12 62 12C59.7909 12 58 10.2091 58 8C58 5.79085 59.7909 4 62 4Z",
    fill: "#63B1EC",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 12C59.7944 12 58 10.2056 58 8C58 5.7944 59.7944 4 62 4C64.2056 4 66 5.7944 66 8C66 10.2056 64.2056 12 62 12Z",
    fill: "#122D5B"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64 8C64 6.89543 63.1046 6 62 6C60.8954 6 60 6.89543 60 8C60 9.10457 60.8954 10 62 10C63.1046 10 64 9.10457 64 8Z",
    fill: "#122D5B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42 14.9468C40.3165 14.9468 38.9468 16.3165 38.9468 18C38.9468 19.6835 40.3165 21.0532 42 21.0532C43.6835 21.0532 45.0532 19.6835 45.0532 18C45.0532 16.3165 43.6835 14.9468 42 14.9468ZM42 14C44.2091 14 46 15.7909 46 18C46 20.2091 44.2091 22 42 22C39.7909 22 38 20.2091 38 18C38 15.7909 39.7909 14 42 14Z",
    fill: "#63B1EC",
    fillOpacity: 0.1
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42 22C39.7944 22 38 20.2056 38 18C38 15.7944 39.7944 14 42 14C44.2056 14 46 15.7944 46 18C46 20.2056 44.2056 22 42 22Z",
    fill: "#122D5B"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 18C44 16.8954 43.1046 16 42 16C40.8954 16 40 16.8954 40 18C40 19.1046 40.8954 20 42 20C43.1046 20 44 19.1046 44 18Z",
    fill: "#122D5B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81 0.946786C79.3165 0.946786 77.9468 2.31645 77.9468 4C77.9468 5.68355 79.3165 7.05321 81 7.05321C82.6835 7.05321 84.0532 5.68355 84.0532 4C84.0532 2.31645 82.6835 0.946786 81 0.946786ZM81 0C83.2091 0 85 1.79085 85 4C85 6.20915 83.2091 8 81 8C78.7909 8 77 6.20915 77 4C77 1.79085 78.7909 0 81 0Z",
    fill: "#63B1EC",
    fillOpacity: 0.1
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81 8C78.7944 8 77 6.2056 77 4C77 1.7944 78.7944 0 81 0C83.2056 0 85 1.7944 85 4C85 6.2056 83.2056 8 81 8Z",
    fill: "#122D5B"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83 4C83 2.89543 82.1046 2 81 2C79.8954 2 79 2.89543 79 4C79 5.10457 79.8954 6 81 6C82.1046 6 83 5.10457 83 4Z",
    fill: "#122D5B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23 19.9468C21.3165 19.9468 19.9468 21.3165 19.9468 23C19.9468 24.6835 21.3165 26.0532 23 26.0532C24.6835 26.0532 26.0532 24.6835 26.0532 23C26.0532 21.3165 24.6835 19.9468 23 19.9468ZM23 19C25.2091 19 27 20.7909 27 23C27 25.2091 25.2091 27 23 27C20.7909 27 19 25.2091 19 23C19 20.7909 20.7909 19 23 19Z",
    fill: "#63B1EC",
    fillOpacity: 0.1
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23 27C20.7944 27 19 25.2056 19 23C19 20.7944 20.7944 19 23 19C25.2056 19 27 20.7944 27 23C27 25.2056 25.2056 27 23 27Z",
    fill: "#122D5B"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25 23C25 21.8954 24.1046 21 23 21C21.8954 21 21 21.8954 21 23C21 24.1046 21.8954 25 23 25C24.1046 25 25 24.1046 25 23Z",
    fill: "#122D5B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4 24.9468C2.31645 24.9468 0.946786 26.3165 0.946786 28C0.946786 29.6835 2.31645 31.0532 4 31.0532C5.68355 31.0532 7.05321 29.6835 7.05321 28C7.05321 26.3165 5.68355 24.9468 4 24.9468ZM4 24C6.20915 24 8 25.7909 8 28C8 30.2091 6.20915 32 4 32C1.79085 32 0 30.2091 0 28C0 25.7909 1.79085 24 4 24Z",
    fill: "#63B1EC",
    fillOpacity: 0.1
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 32C1.7944 32 0 30.2056 0 28C0 25.7944 1.7944 24 4 24C6.2056 24 8 25.7944 8 28C8 30.2056 6.2056 32 4 32Z",
    fill: "#122D5B"
  }))), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M6 28C6 26.8954 5.10457 26 4 26C2.89543 26 2 26.8954 2 28C2 29.1046 2.89543 30 4 30C5.10457 30 6 29.1046 6 28Z",
    fill: "#122D5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrendsReport);
export default __webpack_public_path__ + "static/media/trends-report.05664b3b833a7bb423fc35e3d1ae2de4.svg";
export { ForwardRef as ReactComponent };